import { IBasicCard } from './basicCard.modules';
import * as S from './basicCard.style';
import { organizeBasicCard } from './basicCard.organize';

/**
 * This card is meant to be used whenever the design or editors need the maximum personalization
 * It's composed by a TITLE and an array of TEXTS, both of them free HTML
 * For each section the editor can specify the fontSize (for each breakpoint), and a font color.
 * Both the TITLE and the TEXT have a basic style that would be overwritten ONLY if the editor choose to do it
 */

export const BasicCard = ({ title, texts }: IBasicCard) => {
  const { purifiedData } = organizeBasicCard({ title, texts });

  return (
    <S.Container>
      {purifiedData?.title?.text && (
        <S.Title
          fontSize={purifiedData?.title?.fontSize}
          color={purifiedData?.title?.color}
          dangerouslySetInnerHTML={{
            __html: purifiedData?.title?.text,
          }}
        />
      )}

      {purifiedData?.texts &&
        purifiedData?.texts?.map((t) => (
          <S.Text
            fontSize={t?.fontSize}
            color={t?.color}
            dangerouslySetInnerHTML={{
              __html: t?.text || '',
            }}
          />
        ))}
    </S.Container>
  );
};
